var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('x-header',[_vm._v("支付订单")]),_vm._v(" "),_vm._l((_vm.payList),function(item,index){return _c('cell',{key:index,attrs:{"title":item,"is-link":"","link":{name:'Payinfo',query:{seq:item,payList: _vm.payList,role: _vm.role}}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eec52574","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Userpay.vue
// module id = null
// module chunks = 